<template>
  <div class="personnel-portrait-content">
    <div class="content-header">
      <e-form
        :field-list="formInfo.fieldList"
        :data="formInfo.data"
        :list-type-info="formInfo.listTypeInfo"
        ref="formRef"
        @handleEvent="formChange('formInfo',$event)"
      >
        <template v-slot:form-submit>
          <el-button type="primary" @click="queryInfo">查询</el-button>
          <el-button type="primary" @click="resetForm">重置</el-button>
        </template>
      </e-form>
    </div>
    <div class="content">
      <div class="content-row">
        <div class="content-column">
          <div class="content-title fix-detail-style">整体达标趋势
            <router-link :to="overallcomplianceDetailPath">详情></router-link>
          </div>
          <chart
            :chartConfig="[
                {
                  name:'lineChart',
                  option: OverallTrendConfig.option,
                  load: OverallTrendConfig.load,
                  clear: OverallTrendConfig.clear,
                }
              ]"
          ></chart>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50">
          <chart
            :chartConfig="[
              {
                name:'scatterChart',
                option: workHourQualified.option,
                load: workHourQualified.load,
                clear: workHourQualified.clear,
              }
            ]"
          />
        </div>
        <div class="content-column content-column-50">
          <div class="export-btn-style" @click="exportTop">导出</div>
          <div class="table-title-style">所有人员综合排名</div>
          <lb-table
          :height="411"
          :column="tableTopDataColumn"
          :data="tableTopData.data"
          @sort-change="onTopTableChange"
          :total="tableTopData.totalCount"
          :page-sizes="[10]"
          :current-page="tableTopData.pageNo"
          :pagination="true"
          border
          @current-change="onTopTableSizeChange"
          >
          </lb-table>
        </div>
      </div>
      <div class="content-row">
        <div class="content-column content-column-50">
          <chart
            :chartConfig="[
              {
                name:'barChart',
                option: supQualified.option,
                load: supQualified.load,
                clear: supQualified.clear,
              }
            ]"
          />
        </div>
        <div class="content-column content-column-50">
          <chart
            :chartConfig="[
              {
                name:'barChart',
                option: proLQualified.option,
                load: proLQualified.load,
                clear: proLQualified.clear,
              }
            ]"
          />
        </div>
      </div>
      <div class="content-row">
        <div class="content-column">
          <div class="content-title fix-detail-style">人员未达标情况分布
            <router-link :to="abnormalPath">详情></router-link>
          </div>
          <div>
            <e-form
              :field-list="notQuaField"
              :data="notQuaFieldData"
              :list-type-info="notQuaFieldList"
              @handleEvent="handleNotQuaSelect"
            />
          </div>
          <div>
            <chart
              :chartConfig="[
                {
                  name:'barChart',
                  option: notquaConfig.option,
                  load: notquaConfig.load,
                  clear: notquaConfig.clear,
                }
              ]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EForm from '@/components/EForm/index'
import LbTable from '@/components/lb-table/lb-table'
import {
  formInfo,
  OverallTrendConfig,
  workHourQualified,
  tableTopDataColumn,
  tableTopData,
  supQualified,
  proLQualified,
  notQuaField,
  notQuaFieldData,
  notQuaFieldList,
  notquaConfig
} from './config'
import chart from '@/components/chart/index'
import { computedSeries } from '@/utils/util'
import { common } from './mixFun'
import { downloadBlobFile } from '@/utils/download'
import {
  getPassRate,
  getOperatorPassDistribution,
  getOperatorRank,
  getPassCount,
  getTopRank,
  getDistribution
} from '@/api/personnelWorkHour'
export default {
  name: 'index',
  mixins: [common],
  components: {
    EForm,
    chart,
    LbTable
  },
  data () {
    return {
      formInfo,
      OverallTrendConfig,
      workHourQualified,
      tableTopDataColumn,
      tableTopData,
      supQualified,
      proLQualified,
      notQuaField,
      notQuaFieldData,
      notQuaFieldList,
      notquaConfig,
      formData: formInfo.data,
      isIframe: false,
      overallcomplianceDetailPath: '',
      abnormalPath: ''
    }
  },
  mounted () {
    this.isIframe = window.location.href.search('iframe=1') !== -1
    this.overallcomplianceDetailPath = '/personnel-workhour/personnel-workhour-overview/OverallcomplianceDetail'
    this.abnormalPath = '/personnel-workhour/personnel-workhour-overview/Abnormal'
    if (this.isIframe) {
      this.overallcomplianceDetailPath = this.overallcomplianceDetailPath + '?iframe=1'
      this.abnormalPath = this.abnormalPath + '?iframe=1'
    }
    this.init()
  },
  methods: {
    init () {
      this.queryInfo()
    },
    handleNotQuaSelect ({ event, value }) {
      switch (event) {
        case 'origin':
          this.notQuaFieldData.origin = value
          break
        case 'rationality':
          this.notQuaFieldData.rationality = value
          break
      }
      this.getNotquaData(this.notQuaFieldData)
    },
    onTopTableChange (value) {
      const { order } = value
      this.getTableData({ ...this.tableTopData, sortOrder: order === 'ascending' ? 'asc' : 'desc' })
    },
    onTopTableSizeChange (pageNo) {
      this.getTableData({ pageNo, sortOrder: this.tableTopData.sortOrder })
    },
    async exportTop () {
      const res = await getTopRank({ ...this.formData, sort_order: this.tableTopData.sortOrder })
      downloadBlobFile(res)
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    queryInfo () {
      this.formData = {
        ...this.formData,
        ...this.$refs.formRef.data
      }
      this.drawChart()
    },
    drawChart () {
      this.getOverallTrendData()
      this.getWorkHourData()
      this.getSupperDbData()
      this.proLQualifiedDbData()
      this.getNotquaData()
      this.getTableData()
    },
    // 获取整体趋势折线图数据
    async getOverallTrendData () {
      this.OverallTrendConfig.load = true
      const res = await getPassRate(this.formData)
      this.OverallTrendConfig.option = {
        title: {
          text: '整体达标率'
        },
        tooltip: {
          formatter: (params) => {
            const {marker, axisValueLabel, seriesName, value} = params[0]
            return `
              ${marker}${axisValueLabel}<br/>${seriesName}：${(value * 100).toFixed(2)}%
            `
          }
        },
        legend: {
          data: ['目标', '整体达成率'],
          top: 23
        },
        xAxis: {
          type: 'category',
          data: res.rows
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            formatter (params) {
              return `${Number(params) * 100}%`
            }
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            interval: 0
          }
        },
        series: [
          {
            name: '整体达成率',
            type: 'line',
            label: {
              show: true,
              formatter (params) {
                return `${(Number(params.value) * 100).toFixed(2)}%`
              }
            },
            markLine: {
              data: [
                {
                  name: '目标',
                  yAxis: res.standard
                }
              ],
              label: {
                formatter (value) {
                  return `${Number(value.value) * 100}%`
                }
              },
              lineStyle: {
                color: 'red'
              }
            },
            data: Object.values(res.column).map(item => item[0])
          }
        ]
      }
      this.OverallTrendConfig.load = false
    },
    // 获取人员工时整体达标情况数据
    async getWorkHourData () {
      this.workHourQualified.load = true
      const res = await getOperatorPassDistribution(this.formData)
      const _realData = []
      Object.values(res.column).forEach(item => {
        item.forEach(innerItem => {
          _realData.push({
            ...innerItem,
            value: [innerItem.date, innerItem.value]
          })
        })
      })
      this.workHourQualified.option = {
        title: {
          show: true,
          text: '人员工时整体达标情况'
        },
        dataZoom: {
          start: 60
        },
        xAxis: {
          type: 'category',
          data: res.rows,
          splitLine: {
            show: true
          }
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          triggerOn: 'click',
          formatter (params) {
            const data = params.data
            return `作业员:${data.operator}</br>日期:${data.date}<br/>实际总耗时:${data.real_hs}<br/>达标情况:${data.status}`
          }
        },
        series: [
          {
            type: 'scatter',
            symbolSize: 5,
            markLine: {
              lineStyle: {
                color: 'red'
              },
              data: [
                {
                  yAxis: res.standard
                }
              ]
            },
            data: _realData
          }
        ]
      }
      this.workHourQualified.load = false
    },
    // 获取供应商所有人的达标情况分布数据
    async getSupperDbData () {
      this.supQualified.load = true
      const res = await getPassCount({ ...this.formData, dimension: 'outsourcer' })
      this.supQualified.option = {
        title: {
          text: '分供应商所有人的达标情况分布'
        },
        legend: {
          top: 'middle',
          right: '0',
          orient: 'vertical'
        },
        grid: {
          right: '15%'
        },
        xAxis: {
          type: 'category',
          data: res.rows
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          formatter: (params) => {
            let text = `${params[0].axisValueLabel}`
            params.forEach(item => {
              text += `
                <br/>
                ${item.marker}${item.seriesName}：${item.data.value}，${(item.data.rate * 100).toFixed(2)}%
              `
            })
            return text
          }
        },
        series: [
          {
            type: 'bar',
            name: '达标',
            stack: 'db',
            barWidth: '50%',
            label: {
              show: true
            },
            data: res.rows.map(item => ({value: res.column[item].pass, rate: res.column[item].pass_rate}))
          },
          {
            type: 'bar',
            name: '不达标',
            stack: 'db',
            label: {
              show: true
            },
            data: res.rows.map(item => ({value: res.column[item].no_pass, rate: res.column[item].no_pass_rate}))
          }
        ]
      }
      this.supQualified.load = false
    },
    // 获取分产线所有人的达标情况分布数据
    async proLQualifiedDbData () {
      this.proLQualified.load = true
      const res = await getPassCount({ ...this.formData, dimension: 'production_line' })
      this.proLQualified.option = {
        title: {
          text: '分产线所有人的达标情况分布'
        },
        legend: {
          top: 'middle',
          right: '0',
          orient: 'vertical'
        },
        tooltip: {
          formatter: (params) => {
            let text = `${params[0].axisValueLabel}`
            params.forEach(item => {
              text += `
                <br/>
                ${item.marker}${item.seriesName}：${item.data.value}，${(item.data.rate * 100).toFixed(2)}%
              `
            })
            return text
          }
        },
        grid: {
          right: '15%'
        },
        xAxis: {
          type: 'category',
          data: res.rows
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            name: '达标',
            stack: 'db',
            barWidth: '50%',
            label: {
              show: true
            },
            data: res.rows.map(item => ({value: res.column[item].pass, rate: res.column[item].pass_rate}))
          },
          {
            type: 'bar',
            name: '不达标',
            stack: 'db',
            label: {
              show: true
            },
            data: res.rows.map(item => ({value: res.column[item].no_pass, rate: res.column[item].no_pass_rate}))
          }
        ]
      }
      this.proLQualified.load = false
    },
    // 获取人员未达标情况分布数据
    async getNotquaData (params) {
      this.notquaConfig.load = true
      const res = await getDistribution({ ...this.formData, ...params })
      this.notquaConfig.option = {
        xAxis: {
          type: 'category',
          data: res.rows
        },
        yAxis: {
          type: 'value'
        },
        legend: {
          show: true,
          formatter: '{name}(人)'
        },
        series: computedSeries(res.column, [
          {
            type: 'bar',
            nameEn: 'skill_lack',
            name: '作业技能不足',
            label: {
              show: true,
              position: 'top'
            }
          },
          {
            type: 'bar',
            nameEn: 'job_dispatch',
            name: '任务调度',
            label: {
              show: true,
              position: 'top'
            }
          },
          {
            type: 'bar',
            nameEn: 'vacation',
            name: '假期',
            label: {
              show: true,
              position: 'top'
            }
          },
          {
            type: 'bar',
            nameEn: 'platform',
            name: '平台',
            label: {
              show: true,
              position: 'top'
            }
          },
          {
            type: 'bar',
            nameEn: 'train_exam',
            name: '培训/考试',
            label: {
              show: true,
              position: 'top'
            }
          }
        ])
      }
      this.notquaConfig.load = false
    },
    // 获取供应商列表数据
    async getTableData ({ pageNo, sortOrder } = { pageNo: 1, sortOrder: 'desc' }) {
      const res = await getOperatorRank({
        ...this.formData,
        pageNo: pageNo || this.tableTopData.pageNo,
        pageSize: this.tableTopData.pageSize,
        sort_order: sortOrder
      })
      this.tableTopData = res
      this.tableTopData.sortOrder = sortOrder
    }
  }
}
</script>

<style scoped lang="less">
@import "../../utils/utils";

.fix-detail-style {
  display: flex;
  justify-content: space-between;
}
.table-title-style{
  font-size: 14px;
  text-align: center;
}
.export-btn-style{
  cursor: pointer;
  color: #5ABFE8;
  font-size: 14px;
  text-align: right;
}
</style>
